/**
 * @deprecated This service has been consolidated into src/services/blueprint/BlueprintService.ts
 * This file is maintained for backward compatibility only.
 * Please update imports to use: import { BlueprintService } from './blueprint';
 */

// Re-export types
export type { Requirements } from './blueprint/BlueprintService';

// Backward compatibility - maintain old class name
import { BlueprintService as ConsolidatedBlueprintService } from './blueprint/BlueprintService';

/**
 * @deprecated Use BlueprintService from './blueprint' instead
 */
export class BlueprintGeneratorService extends ConsolidatedBlueprintService {}
